import React, { useState, useEffect } from 'react';
import { Button, Space, Table } from '@drip/drip-design';
import { CheckCircleFilled, CloseCircleFilled } from '@drip/drip-design-icons';
import { alreadyApplyWhite } from '../apis.js';
import env from '@/env';
import { formateTimeStamp } from '@/common/utils';
import ComponentLog from '@/components/component-log';

interface PropsType {
  businessType: number; // 活动类型,1:主题活动
  businessId?: string; // 活动code
  tabType: string;
  whiteTemplateId?: number;
}

const getOaUrl = (appId: string) => {
  return `${env.WHITE_OA_DOMAIN}/pc/view?processInstanceId=${appId}`;
};

function AppliedWhite(props: PropsType) {
  const { businessType, businessId, tabType, whiteTemplateId } = props;

  const [loading, setLoading] = useState(false);
  const [appliedWhiteList, setAppliedWhiteList] = useState([]);

  useEffect(() => {
    if (tabType !== '2') {
      return;
    }
    setLoading(true);
    const params: { businessType: number; businessId?: string; whiteTemplateId?: number } = {
      businessType,
      businessId,
    };
    if (whiteTemplateId && [3].includes(businessType)) {
      params.whiteTemplateId = whiteTemplateId;
    }
    alreadyApplyWhite(params)
      .then(({ ret, data }) => {
        if (ret === '0' && data) {
          setAppliedWhiteList(data?.list);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [businessType, businessId, tabType]);

  const getColumns = () => {
    let columns: any = [
      {
        dataIndex: 'whiteName',
        title: '白名单名称',
        width: 150,
      },
      {
        dataIndex: 'permissionName',
        title: '申请信息',
        width: 150,
        render: (val: string, record: any) => {
          return (
            <div>
              <div>类型：{val}</div>
              <div>申请人：{record?.applyErp || '-'}</div>
              <div>申请时间：{formateTimeStamp(record?.applyTime, true)}</div>
            </div>
          );
        },
      },
      //审核状态 0：审核中 1：审核通过 2：审核未通过 3：用户取消申请，4：申请失效
      {
        dataIndex: 'auditStatus',
        title: '审核状态',
        width: 60,
        render: (val: number, record: any) => {
          return (
            <div>
              {val === 1 ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                  <CheckCircleFilled
                    style={{ fontSize: '20px', color: '#1EC337', verticalAlign: 'middle', marginRight: '10px' }}
                  />
                  <span style={{ verticalAlign: 'middle' }}>已通过</span>
                </div>
              ) : val === 0 ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                  {/* <LoadingOutlined
                    style={{ fontSize: '20px', color: '#51b1fe', verticalAlign: 'middle', marginRight: '10px' }}
                  /> */}
                  <span style={{ verticalAlign: 'middle', whiteSpace: 'nowrap' }}>审核中</span>
                </div>
              ) : val === 3 ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                  <span style={{ verticalAlign: 'middle', whiteSpace: 'nowrap' }}>已退出</span>
                </div>
              ) : val === 4 ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                  <span style={{ verticalAlign: 'middle', whiteSpace: 'nowrap' }}>申请失效</span>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                  <CloseCircleFilled
                    style={{ fontSize: '20px', color: '#FF3126', verticalAlign: 'middle', marginRight: '10px' }}
                  />
                  <span style={{ verticalAlign: 'middle' }}>审核驳回</span>
                </div>
              )}
            </div>
          );
        },
      },
      {
        dataIndex: 'failNum',
        title: '失败数',
        width: 80,
        render: (val: number, record: any) => {
          return (
            <div>
              {val > 0 ? (
                <div>
                  <span style={{ color: 'red' }}> {val}</span>个
                  <Button style={{ padding: 0, marginLeft: '5px' }} type="link" href={record?.failUrl}>
                    下载失败文件
                  </Button>
                </div>
              ) : (
                '-'
              )}
            </div>
          );
        },
      },
      {
        dataIndex: 'operates',
        title: '操作',
        render: (val: number[] | null, record: any) => {
          return (
            <Space wrap={true}>
              <ComponentLog clstag="yx_whiteapply_page_1706591686206|11">
                <a target="_blank" href={getOaUrl(record?.applyId)} rel="noreferrer">
                  查看详情
                </a>
              </ComponentLog>
              <a href={record?.ossFileName}>下载白名单</a>
            </Space>
          );
        },
        width: 70,
      },
    ];
    return columns;
  };

  return (
    <div>
      <h3>已提交白名单</h3>
      <Table
        loading={loading}
        bordered
        style={{ marginTop: '20px' }}
        scroll={{ x: 1000, y: 420 }}
        columns={getColumns()}
        dataSource={appliedWhiteList || []}
        pagination={false}
      />
    </div>
  );
}

export default AppliedWhite;
